import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5154118"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding-top":"64px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpecialActiveHeader = _resolveComponent("SpecialActiveHeader")!
  const _component_HomeHeader = _resolveComponent("HomeHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_HomeAbout = _resolveComponent("HomeAbout")!
  const _component_HomeFooter = _resolveComponent("HomeFooter")!
  const _component_FixedButtonGroup = _resolveComponent("FixedButtonGroup")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.specialActiveList.includes(+_ctx.currentItemId))
      ? (_openBlock(), _createBlock(_component_SpecialActiveHeader, { key: 0 }))
      : (_openBlock(), _createBlock(_component_HomeHeader, { key: 1 })),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    (_ctx.SHOW_BRAND)
      ? (_openBlock(), _createBlock(_component_HomeAbout, { key: 2 }))
      : _createCommentVNode("", true),
    _createVNode(_component_HomeFooter),
    _createVNode(_Transition, {
      name: "slide-fade",
      appear: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FixedButtonGroup)
      ]),
      _: 1
    })
  ]))
}